import axios from 'axios'
import { BatchPrintingTemplateResponse } from '@/api/services/common/batch-printing-dashboard/batch-printing-dashboard.dto'

class CommonBatchPrintingDashboardService {
    async getBatchPrintingTemplatesByLaboratory(laboratoryId: number): Promise<BatchPrintingTemplateResponse[]> {
        const response = await axios.get<BatchPrintingTemplateResponse[]>(`/dashboard/laboratories/${laboratoryId}/batchPrintingTemplate`)
        return response.data
    }
}
export const commonBatchPrintingDashboardService = new CommonBatchPrintingDashboardService()
